module.exports = __webpack_public_path__ + "static/media/tag_party.76063b7e.png";